import OBase from './OBase';
import * as Geometry from '../geometry';
import { scaleBooleanInput, rescaleBooleanOutput, rescaleBooleanOutput2 } from '../GHBooleanUtils';

export default class EUnion extends OBase {
  update () {
    let aTree = this.getSurfaceObjectInput('A');
    let output = this.getGenericObjectOutput('surface');

    let outTree = new Geometry.DataTree();
    for (let i = 0; i < aTree.branches.length; i++) {
      // let solution = EUnion.createUnion(aTree.branches[i])
      let solutions = EUnion.createUnion2(aTree.branches[i]);

      for (let j = 0; j < solutions.length; j++) {
        outTree.add(solutions[j], aTree.paths[i]);
      }
    }

    output.value = outTree;
  }

  static createUnion (aList) {
    aList = scaleBooleanInput(aList);

    let clipper = new ClipperLib.Clipper();
    for (let j = 0; j < aList.length; j++) {
      let a = aList[j];
      // console.log(a)
      if (j === 0) {
        clipper.AddPaths(a, ClipperLib.PolyType.ptSubject, true);
      } else {
        clipper.AddPaths(a, ClipperLib.PolyType.ptClip, true);
      }
    }
    let solution = new ClipperLib.Paths();
    clipper.Execute(ClipperLib.ClipType.ctUnion, solution, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);

    return rescaleBooleanOutput(solution);
  }

  static createUnion2 (aList) {
    aList = scaleBooleanInput(aList);
    let clipper = new ClipperLib.Clipper();
    for (let j = 0; j < aList.length; j++) {
      let a = aList[j];
      if (j === 0) {
        clipper.AddPaths(a, ClipperLib.PolyType.ptSubject, true);
      } else {
        clipper.AddPaths(a, ClipperLib.PolyType.ptClip, true);
      }
    }

    let solution2 = new ClipperLib.PolyTree();
    clipper.Execute(ClipperLib.ClipType.ctUnion, solution2, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
    let newSolutions = [];
    let polys = solution2.m_Childs;
    for (let i = 0; i < polys.length; i++) {
      let poly = polys[i];

      EUnion.recursiveSolution(poly, newSolutions);
    }

    return rescaleBooleanOutput2(newSolutions);
  }

  static recursiveSolution (poly, newSolutions) {
    if (poly.IsOpen === false) {
      let newSolution = [];
      let childs = poly.m_Childs;
      newSolution.push(poly.m_polygon);
      for (let j = 0; j < childs.length; j++) {
        let child = childs[j];
        if (child.IsOpen === false) {
          if (child.IsHole()) {
            newSolution.push(child.m_polygon);

            for (let k = 0; k < child.m_Childs.length; k++) {
              this.recursiveSolution(child.m_Childs[k], newSolutions);
            }
          }
        }
      }
      newSolutions.push(newSolution);
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/EUnion.js